import { useNode } from '@craftjs/core';
import { useFormContext } from 'react-hook-form';
import { useFieldState } from 'src/features/generalForms/builder/layout/panels/helpers/expression/useFieldState';
import { FormSliderInputComponent } from 'src/features/generalForms/builder/types/SliderInput';
import { HookFormSliderInputField } from 'src/features/generalForms/uikit/hookFormFields/hookFormSliderInputField';
import { useHookFieldErrors } from 'src/helpers/error-helpers';
import { hookFormRules } from '../../../fillingModal/react-hook-form-helper';

export const FormSliderInput: FormSliderInputComponent = (props) => {
  const { styles } = useNode((node) => ({
    styles: node.data.custom,
  }));
  const form = useFormContext();
  const { paddingBottom, paddingLeft, paddingRight, paddingTop, ...restStyles } = styles;
  const { visible, isDisabled } = useFieldState(form);
  const errors = useHookFieldErrors(props.dataKey!);

  if (!visible) {
    return <></>;
  }

  return (
    <div
      style={{
        paddingBottom,
        paddingLeft,
        paddingRight,
        paddingTop,
        boxSizing: 'border-box',
        ...restStyles,
      }}
    >
      <HookFormSliderInputField
        control={form.control}
        name={props.dataKey!}
        disabled={isDisabled}
        labelProps={{
          text: props.title,
          isBold: true,
          tooltip: props.tooltip,
          description: props.description,
          isOptional: props.isOptional,
          prefix: props.prefix,
        }}
        rules={hookFormRules({
          required: !props.isOptional && !isDisabled,
        })}
        errorProps={{ errors }}
        startPoint={props.startPoint}
        caption={{
          startText: props.captionStartText,
          centerText: props.captionCenterText,
          endText: props.captionEndText,
        }}
        startWith={props.minValue ?? 0}
        endWith={props.maxValue ?? 10}
        showMarks={!props.hideMarks}
        showNumberInput={props.showNumberInput}
        marksStep={props.marksStep}
        colorScheme={props.colorScheme}
        defaultValue={props.defaultValue}
        key={props.dataKey}
        step={props.step}
      />
    </div>
  );
};
